import api from '__jsVueApi';

export default {
	async loadListOfStatuses({ state, commit }) {
		// await axios
		// 	.get(api.main.statuses.get)
		// 	.then(response => {
		// 		commit('setListOfStatuses', response.data);
		// 	})
		// 	.catch(err => {
		// 		throw new Error(err);
		// 	});
		commit('setListOfStatuses', [
			{ label: 'Analyzing', value: 'analyzing' }, { label: 'Made offer', value: 'made_offer' }, { label: 'Offer accepted', value: 'offer_accepted' }, { label: 'Closed', value: 'closed' }, { label: 'Sold it', value: 'sold_it' }, { label: 'No deal', value: 'no_deal' }
		]);
	},
};
